module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSolicitante(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Competência")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.distribuicao_id),
      expression: "filtros.distribuicao_id"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "distribuicao_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.distribuicoes), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(_vm._f("competencia")(item.data_competencia)))])
  }))])])]), _vm._v(" "), _c('div', {
    ref: "filtrar",
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "disabled": !_vm.finalizado,
      "data-toggle": "tooltip",
      "title": "Pesquisar Relatório de Solicitação",
      "id": "resultado"
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar\n              ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive form-group"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.unidade.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")((parseFloat(item.limite_geral) + parseFloat(item.total_consumido_geral)), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(parseFloat(item.total_consumido_geral), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(parseFloat(item.limite_geral), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")((parseFloat(item.total_disponivel_procedimento) + parseFloat(item.total_consumido_procedimento)), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(parseFloat(item.total_consumido_procedimento), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(parseFloat(item.total_disponivel_procedimento), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")((parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_consumido_subgrupo)), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(parseFloat(item.total_consumido_subgrupo), 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(parseFloat(item.total_disponivel_subgrupo), 2, ',', '.')))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("numberFormat")((parseFloat(item.limite_geral) + parseFloat(item.total_consumido_geral) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.total_consumido_procedimento) + parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_consumido_subgrupo)), 2, ',', '.')))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("numberFormat")((parseFloat(item.total_consumido_subgrupo) + parseFloat(item.total_consumido_procedimento) + parseFloat(item.total_consumido_geral)), 2, ',', '.')))])]), _vm._v(" "), _c('td', [((parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)) > 0) ? _c('strong', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(_vm._f("numberFormat")((parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)), 2, ',', '.')))]) : _vm._e(), _vm._v(" "), ((parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)) == 0) ? _c('strong', [_vm._v(_vm._s(_vm._f("numberFormat")((parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)), 2, ',', '.')))]) : _vm._e(), _vm._v(" "), ((parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)) < 0) ? _c('strong', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(_vm._f("numberFormat")((parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)), 2, ',', '.')))]) : _vm._e()])])
  }))])]), _vm._v(" "), (_vm.dataTable.data && _vm.dataTable.data.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  })]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Consumo de Limites")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("UNIDADE")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("LIMITE POR GERAL")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("LIMITE POR PROCEDIMENTO")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("LIMITE POR SUBGRUPO")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("LIMITE TOTAL")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("---")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Consumido")]), _vm._v(" "), _c('th', [_vm._v("Disponível")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Consumido")]), _vm._v(" "), _c('th', [_vm._v("Disponível")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Consumido")]), _vm._v(" "), _c('th', [_vm._v("Disponível")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("Consumido")]), _vm._v(" "), _c('th', [_vm._v("Disponível")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-81043f58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administracao/relatorios/consumo_limites/index.vue
// module id = 879
// module chunks = 0